import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

/**
 * Batch 59 — GoHighLevel expert in the Philippines cluster service links.
 *
 * Every Batch 59 article routes its primary commercial link to
 * /gohighlevel-revops-architect. The answer-first leads in batch59Content.ts
 * embed the link directly, but the lead-swap idempotency guard can drop the
 * lead when the Quick Answer duplicates the lead text. This map is the
 * RELIABLE fallback: `injectBatchServiceLink` (batchContentOptimizer.ts) wraps
 * the first in-body occurrence of each anchor phrase in a
 * /gohighlevel-revops-architect link, so the contextual service link always
 * renders regardless of the lead swap.
 *
 * Anchors are distinctive body phrases (not in the H1) so the link injects
 * into the article body, never the headline.
 */
export const BATCH59_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  "gohighlevel-expert-philippines-interview-test": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /candidate who stalls on the build is a candidate who memorized the exam/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-philippines-team-vs-solo-hire": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /solo hire who scales past 20 sub-accounts is a solo hire who buries the critical ticket/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-expert-philippines-data-security": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /remote hire who keeps the sub-account access after the contract is a hire who keeps your data/i,
    label: "hire a GoHighLevel RevOps architect",
  },
  "gohighlevel-philippines-hiring-mistakes": {
    url: "/gohighlevel-revops-architect",
    anchor:
      /GoHighLevel expert in the Philippines who ships the badge and keeps the snapshot is an expert who leaves you with the dependency/i,
    label: "hire a GoHighLevel RevOps architect",
  },
};
